import { render } from "./reporting.vue?vue&type=template&id=08ebc6aa&scoped=true&ts=true"
import script from "./reporting.vue?vue&type=script&lang=ts"
export * from "./reporting.vue?vue&type=script&lang=ts"

import "./reporting.vue?vue&type=style&index=0&id=08ebc6aa&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ebc6aa"]])

export default __exports__